<small class="ao-red" *ngIf="isInvalid" [attr.data-cy]="'application-form-invalid-' + dataCy + '-text'"
  >Invalid {{ labelName }}.</small
>
<small class="ao-red" *ngIf="isRequired" [attr.data-cy]="'application-form-invalid-' + dataCy + '-text'"
  >Your {{ labelName }} is required.</small
>
